import {RequestService} from '../service/request.service';
import {Injectable} from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router, CanLoad, Route} from '@angular/router';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class AdminGuard implements CanActivate, CanLoad {

  constructor(
    private requestService: RequestService,
    private router: Router
  ) {}

  private availAdmin(): boolean | Observable<boolean> {
    return this.requestService._raw().get('/api/access/admin').map((res) => {
      if (res.status === 200) {
        return true;
      } else {
        this.router.navigate(['/404']);
        return false;
      }
    });
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> {
    return this.availAdmin();
  }
  canLoad(route: Route): boolean | Observable<boolean> | Promise<boolean> {
    return this.availAdmin();
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/authguard/adminguard.service.ts